import apiClient from './api';

function normalizeStatusPayload(status = {}) {
  if (!status || typeof status !== 'object') return null;
  return {
    aircraft: Number(status?.aircraft_count || 0),
    pilots: Number(status?.pilot_count || 0),
    flights: Number(status?.flight_count || 0),
    fixedCosts: Boolean(status?.completed?.fixed_costs ?? Number(status?.fixed_cost_count || 0) > 0),
    safety: Boolean(status?.completed?.safety ?? status?.safety_assessment_current),
    whatsapp: status?.completed?.whatsapp ?? status?.has_whatsapp,
    loading: false,
    unavailable: false,
  };
}

export const onboardingStatusService = {
  async getStatus(config = {}) {
    const response = await apiClient.get('/onboarding/status/', {
      __cacheTtlMs: 30000,
      ...config,
    });
    return response.data;
  },

  getCachedStatus() {
    try {
      if (typeof apiClient.getCachedDataSync !== 'function') return null;
      return apiClient.getCachedDataSync({ url: '/onboarding/status/' }) || null;
    } catch {
      return null;
    }
  },

  toCounts(status = {}) {
    return normalizeStatusPayload(status);
  },
};

export default onboardingStatusService;
